import React from 'react';
import { UserProvider } from './store/UserContext';
import { StudentStoreProvider } from './store/StudentStore';
import { SettingsProvider } from './store/SettingsContext';
import { DisplaySettingsProvider } from './store/DisplaySettingsContext';
import { StudentPortalProvider } from './store/StudentPortalContext';
import { FeaturePackProvider } from './store/FeaturePackContext';
import AppRouter from './app/AppRouter';

export default function SafeguardProApp() {
  return (
    <UserProvider>
      <StudentPortalProvider>
        <DisplaySettingsProvider>
          <FeaturePackProvider>
            <SettingsProvider>
              <StudentStoreProvider>
                <AppRouter />
              </StudentStoreProvider>
            </SettingsProvider>
          </FeaturePackProvider>
        </DisplaySettingsProvider>
      </StudentPortalProvider>
    </UserProvider>
  );
}
